// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import Debounce from "lodash-es/debounce";
function useIsScrolling(debounceMsOpt, containerRef) {
  var debounceMs = debounceMsOpt !== undefined ? debounceMsOpt : 500;
  var match = React.useState(function () {
    return false;
  });
  var setScrolling = match[1];
  var container = Belt_Option.getWithDefault(Caml_option.nullable_to_opt(containerRef.current), window);
  var handleEndScroll = React.useMemo(function () {
    return Debounce(function (param) {
      Curry._1(setScrolling, function (param) {
        return false;
      });
    }, debounceMs);
  }, []);
  var handleScrolling = React.useCallback(function (param) {
    Curry._1(setScrolling, function (i) {
      return true;
    });
    return Curry._1(handleEndScroll, undefined);
  }, [setScrolling]);
  React.useEffect(function () {
    container.addEventListener("scroll", handleScrolling);
    return function (param) {
      container.removeEventListener("scroll", handleScrolling);
    };
  }, []);
  return match[0];
}
export { useIsScrolling };
/* react Not a pure module */